
export const ROLE = {
    SUPERADMIN: "super admin",
    USERADMIN: "user admin",
    USER: 'user'
}